import styled from 'styled-components';

// componente de configuração do sistema
export const ConfiguracaoSistemaComponent = styled.div.attrs({
    className: ''
})`



`;